import { Space, Tooltip, notify } from "components/common"
import { BayutLogo, CallCenterIc, IconInstagram, IconTikTok, LandingPageIcon, SnapchatIcon } from "components/svg"
import { configs } from "configs"
import { getAppLanguage } from "configs/useInitializeApp"
import { YYYY_MM_DD_FORMAT } from "constants"
import { NAME_SPACE } from "constants/app-paths"
import dayjs from "dayjs"
import { t } from "i18next"
import { Fragment } from "react"
import { FaFacebook, FaLinkedin, FaPinterest, FaReddit, FaWhatsapp, FaYoutube } from "react-icons/fa"
import { FaSquareXTwitter } from "react-icons/fa6"
import { FcGoogle } from "react-icons/fc"
import store from "store"
import theme from "./themeVars"
import { regex } from "constants/regex"

const state = store.getState()
const currency =
  state?.app?.user?.info?.Agent?.AgencySettings?.find(currency => currency?.key === "primary_currency")?.currencyCode ||
  "PKR"

const { locale } = state.app.configs
const countryCode = state?.app?.user?.info?.Country?.locCode || "PK"

export const getErrorString = errorObj => {
  const errors = errorObj?.errors || errorObj?.error || errorObj?.message
  if (errors) {
    if (Array.isArray(errors)) {
      const messageArray = errors.map(error => error.message)
      return messageArray.join(" ")
    }
    if (typeof errors === "string") return errors
    if (typeof errors === "object")
      return Object.keys(errors)
        .map(key => errors[key])
        .join(", ")
  }
}

export const convertQueryObjToString = obj => {
  if (!obj) return ""
  const keys = Object.keys(obj)
  return keys
    .map(key => (obj[key] === null || obj[key] === undefined ? "" : `${key}=${obj[key]}`))
    .filter(e => !!e)
    .join("&")
}

export const filterCriteria = (inputValue, option, getOptionLabel) => {
  const normalizedInput = inputValue?.toLowerCase().trim()
  const label = getOptionLabel(option)?.toString()?.toLowerCase().trim()

  if (label?.includes(normalizedInput)) {
    return true
  }
  const wordsInLabel = []

  for (let i = 0; i < label?.length; i++) {
    if (label[i] === " ") {
      wordsInLabel.push(label.substring(i + 1, label.length))
    }
  }

  let found = false
  wordsInLabel.forEach(word => {
    if (word?.includes(normalizedInput)) {
      found = true
    }
  })

  return found
}

export const filterParamsObject = (params, key, value) => {
  let paramsObj = { ...params }
  if (paramsObj.hasOwnProperty(key) && paramsObj?.staffType === value) delete paramsObj[key]
  return paramsObj
}
export const removeEmptyKeysFromObject = obj => {
  return Object.fromEntries(Object.entries(obj).filter(([_, v]) => !!v))
}

export const capitalizeFirstLetter = (str = "") => {
  return str?.charAt(0).toUpperCase() + str?.slice(1)
}
export const capitalizetillNthLetter = (str = "", position) => {
  let tempStr = ""

  for (let x = 0; x < position; ++x) {
    tempStr = tempStr + str?.charAt(x).toLocaleUpperCase()
  }
  return tempStr + str?.slice(position)
}

export const convertToReadableString = (str = "", allCaps) => {
  const splitted = str?.split("_")
  return splitted?.map((e, i) => (allCaps || i == 0 ? capitalizeFirstLetter(e) : e))?.join(" ")
}

export const removeDuplicates = array => {
  return array?.filter((item, index) => array?.indexOf(item) === index)
}

export const convertCamelCaseToReadable = inputString => {
  const camelCaseRegex = /[a-z]+|[A-Z][a-z]*/g
  const words = inputString?.match(camelCaseRegex) || []
  const result = words.map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ")

  return result
}
export const localisedValue = ({ object, key }) => {
  const language = getAppLanguage()
  const localizedKey = `${key}${language?.locale?.toUpperCase()}`
  return object?.[localizedKey] ? object[localizedKey] : object?.[key]
}

export const mapQueryStringToFilterObject = (search, cb = () => {}) => {
  const queryObj = {}
  const queryString = search?.split("?")[1]
  if (queryString) {
    const items = queryString.split("&")
    for (const item of items) {
      const key = item?.split("=")[0]
      const value = item?.split("=")[1]
      cb(key, value)
      if (key && value) {
        if (queryObj[key]) {
          queryObj[key] += `,${value}`
        } else {
          queryObj[key] = value
        }
      }
    }
  }
  return { queryObj }
}

export const addQueryFilterArray = (filters, searchKey, value, splitString, cb) => {
  const prevVal = filters[searchKey]
  const prevValArr = prevVal ? prevVal.toString().split(splitString) : []
  if (!value) {
    const filtersObj = { ...filters }
    filtersObj[searchKey] = undefined
    cb(filtersObj)
  } else if (!prevValArr.includes(value.toString())) {
    const filtersObj = { ...filters }
    filtersObj[searchKey] = [...prevValArr, value].join(splitString)
    cb(filtersObj)
  }
}

export const addQueryFilterArrayPreSelected = (filters, searchKey, value, splitString, cb) => {
  const obj = { ...filters }
  if (obj[searchKey]) {
    const array = obj[searchKey].split(splitString)
    const index = array.indexOf(value.toString())
    if (array.length > 1) {
      array.splice(index, 1)
      obj[searchKey] = array.join(splitString)
    } else {
      delete obj[searchKey]
    }
  }
  obj.page && delete obj.page
  cb(obj)
}

export const getUniqueArrayByObjKey = (array, key) => {
  return [
    ...new Map(array.map(item => [Array.isArray(key) ? key.map(e => item[e]).join("-") : item[key], item])).values(),
  ]
}

export const fileToBase64 = file => {
  return new Promise(resolve => {
    let baseURL = ""
    let reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      baseURL = reader.result
      resolve(baseURL)
    }
  })
}
export const arrayBufferToBase64 = buffer => {
  var binary = ""
  var bytes = new Uint8Array(buffer)
  var len = bytes.byteLength
  for (var i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i])
  }
  return window.btoa(binary)
}

export const openMailTo = (email, subject = "", body = "", children) => {
  let params = subject || body ? "?" : ""
  if (subject) params += `subject=${encodeURIComponent(subject)}`
  if (body) params += `${subject ? "&" : ""}body=${encodeURIComponent(body)}`
  const mailTo = Array.isArray(email) ? email.join(";") : email
  return window.open(`mailto:${mailTo}${params}`, "_blank")
}

export const getOBJValueByKey = (object, path, defval = null) => {
  if (!path) return defval
  if (typeof path === "string") path = path?.split(".")
  const res = path.reduce(
    (obj, key) =>
      obj && key.includes("[") ? obj[key.substring(1, key.length - 1)] : obj && obj[key] ? obj[key] : defval,
    object
  )
  return res
}

export const withTryCatch = async promise => {
  try {
    const response = await promise()
    return { response }
  } catch (error) {
    return { error: { message: getErrorString(error) } }
  }
}

const getCurrency = val => {
  switch (val) {
    default:
      return "Rs "
  }
}

export const formatCompactedNumber = (num, digit) => {
  let cNumber
  let absNum = Math.abs(num)
  switch (true) {
    case absNum >= 0 && absNum < 1000:
      cNumber = (absNum / 1).toFixed(absNum % 1 ? digit : 0)
      break
    case absNum >= 1000 && absNum < 100000:
      cNumber = (absNum / 1000).toFixed((absNum / 1000) % 1 ? digit : 0) + t("Thousand")
      break
    case absNum >= 100000 && absNum < 10000000:
      cNumber = (absNum / 100000).toFixed((absNum / 100000) % 1 ? digit : 0) + t("Lakh")
      break
    case absNum >= 10000000 && absNum < 1000000000:
      cNumber = (absNum / 10000000).toFixed((absNum / 10000000) % 1 ? digit : 0) + t("Crore")
      break
    case absNum >= 1000000000 && absNum < 100000000000:
      cNumber = (absNum / 1000000000).toFixed((absNum / 1000000000) % 1 ? digit : 0) + t("Arab")
      break
    case absNum >= 100000000000:
      cNumber = (absNum / 100000000000).toFixed((absNum / 100000000000) % 1 ? digit : 0) + t("Kharab")
      break
  }
  return num < 0 ? "-" + cNumber : cNumber
}

export const numberFormat = (value, format, options) => {
  return new Intl.NumberFormat(format, options).format(value)
}

export const internationalFormatCompactedNumber = (value, digit) => {
  let cNumber = true
  let absValue = Math.abs(value)
  switch (true) {
    case absValue > 0 && absValue < 1000:
      cNumber = parseFloat(absValue.toFixed(absValue % 1 ? digit : 0))
      break
    case absValue >= 1000 && absValue < 1000000:
      cNumber = parseFloat((absValue / 1000).toFixed((absValue / 1000) % 1 ? digit : 0)) + " K"
      break
    case absValue >= 1000000 && absValue < 1000000000:
      cNumber = parseFloat((absValue / 1000000).toFixed((absValue / 1000000) % 1 ? digit : 0)) + " M"
      break
    case absValue >= 1000000000 && absValue < 1000000000000:
      cNumber = parseFloat((absValue / 1000000000).toFixed((absValue / 1000000000) % 1 ? digit : 0)) + " B"
      break
    case absValue >= 1000000000000:
      cNumber = parseFloat((absValue / 1000000000000).toFixed((absValue / 1000000000000) % 1 ? digit : 0)) + " T"
      break
    default:
      cNumber = absValue
  }
  return value < 0 ? "-" + cNumber : cNumber
}

export const formatPriceValue = (
  priceValue,
  currencyOptions,
  fractionDigits,
  settings = {
    locale: "en-PK",
    country_code: "PK",
    currency: "PKR",
    timezone: "Asia/Karachi",
  }
) => {
  if (!isNaN(Number(priceValue))) {
    if (currencyOptions?.notation == "compact")
      return getCurrency(settings.currency) + formatCompactedNumber(Number(priceValue), currencyOptions?.dashForNone)
    const fracDigits = !!fractionDigits ? (Number(priceValue) % 1 ? fractionDigits : 0) : Number(priceValue) % 1 ? 2 : 0
    let formattedPrice = new Intl.NumberFormat(settings.locale, {
      currency: settings.currency,
      style: "currency",
      currencyDisplay: "symbol",
      ...(fracDigits <= 2 && { minimumFractionDigits: 0 }),
      maximumFractionDigits: fracDigits,
      ...currencyOptions,
    }).format(priceValue)

    return formattedPrice
  }
  return ""
}

export const joinBytItems = (array, separator) => {
  const filtered = array.filter(e => !!e)
  return filtered.map((e, i) => {
    let formattedElement = e
    if (typeof e === "object" && e.label && e.value) {
      formattedElement = (
        <Fragment key={i + ""}>
          <span>{e.label}: </span>
          {e.value}
        </Fragment>
      )
    }
    if (typeof separator === "string") {
      return i + 1 < filtered.length ? formattedElement + separator : formattedElement
    } else {
      return i + 1 < filtered.length ? (
        <Fragment key={i + ""}>
          {formattedElement}
          {separator}
        </Fragment>
      ) : (
        formattedElement
      )
    }
  })
}

export const getCountryList = (countries, international = false) => {
  if (countries) {
    const list = [...countries]
    const frequentList = [
      ...list.splice(
        list.findIndex(e => e.locCode === "PK"),
        1
      ),
      ...list.splice(
        list.findIndex(e => e.locCode === "AE"),
        1
      ),
      ...list.splice(
        list.findIndex(e => e.locCode === "MA"),
        1
      ),
    ]
    return [
      {
        label: t("Frequently Used"),
        options: international
          ? frequentList.concat({ label: t("International"), value: "international" })
          : frequentList,
      },
      { label: t("All"), options: list },
    ]
  }
  return []
}

export const numberConvertor = (value, compact, digit) => {
  if (compact === "local") {
    return formatCompactedNumber(Number(value), digit)
  } else if (compact === "intl") {
    return internationalFormatCompactedNumber(Number(value), digit)
  } else {
    return Number(value)
  }
}

export const roundValues = (value, decimalPlaces) => Math.round(value, decimalPlaces)

export const convertToHMSString = value => {
  if (isNaN(Number(value))) {
    return value
  }
  if (!value) {
    return "-"
  }
  let v = Number(value)
  const d = Math.floor(v / 86400)
  v -= d * 86400
  const h = Math.floor(v / 3600)
  const m = Math.floor((v % 3600) / 60)
  const s = Math.floor((v % 3600) % 60)
  var daysDisplay = d > 0 ? d + (h == 0 ? "d " : "d, ") : ""
  var hDisplay = h > 0 ? h + (m == 0 ? "h " : "h, ") : ""
  var mDisplay = m > 0 ? m + (s == 0 ? "m " : "m, ") : ""
  var sDisplay = s > 0 ? s + (s == 1 ? "s" : "s") : ""
  return daysDisplay + hDisplay + mDisplay + sDisplay
}

export const base64ToBlob = (base64String, contentType) => {
  const sliceSize = 1024
  const byteCharacters = atob(base64String)
  const byteArrays = []

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize)

    const byteNumbers = new Array(slice.length)
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i)
    }

    const byteArray = new Uint8Array(byteNumbers)
    byteArrays.push(byteArray)
  }

  return new Blob(byteArrays, { type: contentType })
}

export function downloadPDF(pdf, name) {
  const linkSource = `data:application/pdf;base64,${pdf}`
  const downloadLink = document.createElement("a")
  const fileName = `${name}.pdf`
  downloadLink.href = linkSource
  downloadLink.download = fileName
  downloadLink.click()
}

export const downloadFileFromLink = (url, key, src = "link") => {
  const link = document.createElement("a")
  if (src === "link") {
    link.href = url?.[key]
    link.download = url?.filename || url?.fileName
  } else {
    link.href = `data:application/pdf;base64,${url?.data}`
    link.download = url?.fileName
  }
  link.target = "_blank"
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export const downloadMultipleFiles = files => {
  function downloadNextFile(i) {
    if (i >= files.length) {
      notify.success(t("All files have been downloaded successfully"))
      return
    }
    let a = document.createElement("a")
    if (files[i]) {
      a.href = files[i]
      a.target = "_parent"
      document.body.appendChild(a)
      if (a.click) a.click()
      a.parentNode.removeChild(a)
      setTimeout(function () {
        downloadNextFile(i + 1)
      }, 1300)
    } else {
      notify.error(
        `${i} ${t(i === 1 ? "file downloaded successfully" : "files downloaded successfully")}
        - ${files.length - i} ${t(files.length - i === 1 ? "file failed to download" : "files failed to download")}`
      )
      return
    }
  }
  downloadNextFile(0)
}

export const isValidNICFormat = nic => {
  const regex = /^[0-9]{5}-[0-9]{7}-[0-9]$/
  return regex.test(nic)
}
export const getSortedKeys = obj => {
  if (!obj || typeof obj != "object") return obj
  const sortedObj = {}
  Object.keys(obj)
    .sort()
    .forEach(key => {
      sortedObj[key] = obj[key]
    })
  return sortedObj
}

export const convertNumbersToWords = n => {
  if (isNaN(n) || n === "") {
    return "-"
  }

  if (n == 0) {
    return "Zero"
  }

  let isNegative = false
  if (n < 0) {
    isNegative = true
    n = Math.abs(n) // Convert negative number to positive
  }

  let word = ""
  const single_digit = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"]
  const double_digit = [
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ]
  const below_hundred = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"]

  function translate(n) {
    if (n < 10) {
      word = single_digit[n] + " "
    } else if (n < 20) {
      word = double_digit[n - 10] + " "
    } else if (n < 100) {
      const rem = translate(n % 10)
      word = below_hundred[Math.floor(n / 10)] + " " + rem
    } else if (n < 1000) {
      word = single_digit[Math.trunc(n / 100)] + " Hundred " + translate(n % 100)
    } else if (n < 1000000) {
      word = translate(parseInt(n / 1000)).trim() + " Thousand " + translate(n % 1000)
    } else if (n < 1000000000) {
      word = translate(parseInt(n / 1000000)).trim() + " Million " + translate(n % 1000000)
    } else {
      word = translate(parseInt(n / 1000000000)).trim() + " Billion " + translate(n % 1000000000)
    }
    return word
  }

  let result = translate(n)

  if (isNegative) {
    result = "Minus " + result // Append "Minus" for negative numbers
  }

  return result.trim() + "."
}

export const getStoreCacheData = (queryName, queryObj) => {
  const identifier = `${queryName}(${JSON.stringify(getSortedKeys(queryObj))})`
  return store.getState().parentApi.queries[identifier]?.data
}

export const getFileType = filename => {
  return filename?.split(".").pop()
}

export const openGmail = selectedClients => {
  return window.open(
    `https://mail.google.com/mail/?view=cm&fs=1&su=SUBJECT&body=BODY&bcc=${selectedClients
      .map(client => client?.email)
      .toString()}`
  )
}

function dataURLtoFile(dataurl, filename) {
  var arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[arr.length - 1]),
    n = bstr.length,
    u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], filename, { type: mime })
}

export const onS3Upload = async ({ file, getS3, updateS3, path }) => {
  let object = {}
  let fileObject = dataURLtoFile(file?.url, file?.name)
  const fileName = file.name
  const s3Response = await getS3({ path: path({ fileName }) }).unwrap()
  if (s3Response) {
    await updateS3({ url: s3Response.url, file: fileObject })
      .unwrap()
      .then(() => {
        object = { key: s3Response.key, file: file, url: s3Response.url, fileObject: fileObject }
      })
      .catch(error => notify.error(error))
  }
  return object
}

export const deleteKeysWithSubstring = (obj, substring) => {
  const newObj = {}
  for (const key in obj) {
    if (!key.includes(substring)) {
      newObj[key] = obj[key]
    }
  }
  return newObj
}

//TODO: NEEDS TO BE CHANGED FROM BE
export const includeChildren = (obj, keys) => {
  const result = []
  const keySet = new Set(keys)

  const findKeysRecursively = node => {
    result.push(node.value)
    if (node.children) {
      node.children.forEach(child => findKeysRecursively(child))
    }
  }

  const checkChildren = children => {
    children.forEach(child => {
      if (keySet.has(child.value)) {
        findKeysRecursively(child)
      }
      if (child.children) {
        checkChildren(child.children)
      }
    })
  }

  obj.forEach(item => {
    if (keySet.has(item.value)) {
      findKeysRecursively(item)
    } else if (item.children) {
      checkChildren(item.children)
    }
  })

  return result
}

export const getCompactCompositeString = (items = [], showCount, color) => {
  if (items.length > showCount) {
    let stringifiedUnits = items
      .slice(0, showCount)
      .map(e => localisedValue({ object: e, key: "name" }))
      .join(", ")

    let additionalUnits = items
      .slice(showCount)
      .map(e => localisedValue({ object: e, key: "name" }))
      .join(", ")

    let finalString = (
      <Space size={4} wrap>
        {stringifiedUnits}
        <span
          style={{
            color: color || theme["primary-color"],
            bg: theme["primary-light"],
            cursor: "pointer",
          }}
        >
          <Tooltip placement="top" title={additionalUnits}>
            +{items.length - showCount} {t("More")}
          </Tooltip>
        </span>
      </Space>
    )
    return finalString
  }
  return items.map(e => localisedValue({ object: e, key: "name" })).join(", ") || "-"
}

export const openBase64 = filePreview => {
  var byteCharacters = atob(filePreview?.split(",")[1])
  var byteNumbers = new Array(byteCharacters.length)
  for (var i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i)
  }
  var byteArray = new Uint8Array(byteNumbers)
  var file = new Blob([byteArray], { type: filePreview?.split(",")[0].split(":")[1] })
  var fileURL = URL.createObjectURL(file)
  window.open(fileURL)
}

export const isNotImageCheck = file => {
  return !["image/png", "image/jpeg", "png", "jpeg", "jpg"].includes(
    getFileType(file.title || file.type || file.name || file.previewTitle || file.previewImage)
  )
}

export const isPDF = url => {
  return url?.endsWith(".pdf")
}

export const isValidFileType = (allowedFileTypes, file) => {
  return allowedFileTypes.split(/\s*,\s*/).includes(file?.type)
}
export const getAreaUnit = agency => {
  if (agency === "bayut_ksa") return "SqMt"
  return "SqFt"
}

export const convertToSpecificAreaUnit = (value, desiredUnit) => {
  const conversionTable = {
    sq_m: 0.092903,
    kanal: 0.000222222,
    sq_yd: 0.111111,
    sq_f: 1,
    marla: 0.00444444,
    sq_wah: 0.0232558,
    rai: 0.00005807,
    katha: 0.00138889,
  }

  if (!conversionTable.hasOwnProperty(desiredUnit)) {
    throw new Error(`Desired unit '${desiredUnit}' is not a valid unit.`)
  }

  const conversionFactor = conversionTable[desiredUnit]
  const convertedValue = value * conversionFactor

  return convertedValue
}

export const checkIfDurationElapsed = ({ date, duration, durationType }) => {
  if (!date) return true
  return !dayjs(date).isAfter(dayjs().subtract(duration, `${durationType}`))
}

export const isWithinLast24Hours = date => {
  const now = dayjs().startOf("minute")
  const inputDate = dayjs(date).startOf("minute")
  const diffInMinutes = now.diff(inputDate, "minutes")
  const twentyFourHoursInMinutes = 24 * 60
  return diffInMinutes <= twentyFourHoursInMinutes
}

export const iconPlacer = (platform, size) => {
  switch (platform) {
    case "facebook":
      return <FaFacebook color="#1877F2" size={size} />
    case "tik_tok":
      return <IconTikTok size={size} />
    case "twitter":
      return <FaSquareXTwitter size={size} />
    case "instagram":
      return <IconInstagram size={size} />
    case "linkedin":
      return <FaLinkedin color="#0077B5" size={size} />
    case "snap_chat":
      return <SnapchatIcon size={size} />
    case "Pinterest":
      return <FaPinterest color="#E60023" size={size} />
    case "YouTube":
      return <FaYoutube color="#FF0000" size={size} />
    case "Reddit":
      return <FaReddit color="#FF4500" size={size} />
    case "WhatsApp":
      return <FaWhatsapp color="#25D366" size={size} />
    case "google_forms":
      return <FcGoogle size={size} />
    case "landing_page":
      return <LandingPageIcon color={theme["accent-color"]} size={size} />
    case "bayut_web":
      return <BayutLogo size={size} />
    case "call_center":
      return <CallCenterIc color={theme["accent-color"]} size={size} />
    default:
      return null
  }
}

export const canEditTask = item =>
  item?.latestTask && item?.updatedBySource !== "edit_task" && isWithinLast24Hours(item?.createdAt)

export const toCamelCaseFromUnderscore = str => {
  return str
    .split("_")
    .map((word, index) => (index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1)))
    .join("")
}
export const checkDuplicates = array => {
  const uniqueSet = new Set(array)
  return uniqueSet.size !== array.length
}
export const createDateList = (fromDate, toDate) => {
  let dates = []
  let startDate = dayjs(fromDate)
  let endDate = dayjs(toDate)
  while (startDate <= endDate) {
    dates.push(startDate.format(YYYY_MM_DD_FORMAT))
    startDate = startDate.add(1, "days")
  }

  return dates
}
export const removeUnderscore = str => {
  return (str || "").replace(/_/g, " ")
}

export const isTimeWithinRange = (targetRange, specifiedRange) => {
  const toSeconds = t => {
    const [hours, minutes, seconds] = t.split(":").map(Number)
    return hours * 3600 + minutes * 60 + seconds
  }

  const timeStart = toSeconds(targetRange.from)
  const timeEnd = toSeconds(targetRange.to)

  const rangeStart = toSeconds(specifiedRange.from)
  const rangeEnd = toSeconds(specifiedRange.to)

  return timeStart >= rangeStart && timeEnd <= rangeEnd
}

export const flattenHierarchy = node => {
  let result = []
  const { title, value, key, regionId, selfSeller } = node
  result.push({ title, value, key, regionId })
  if (node.children && node.children.length > 0) {
    node.children.forEach(child => {
      result = result.concat(flattenHierarchy(child))
    })
  }
  return result
}
export const concatenateTitleWithDesignation = staffList => {
  return staffList.map(member => {
    const { title, designationTitle } = member
    const updatedTitle = designationTitle ? `${title} (${designationTitle})` : title
    return {
      ...member,
      title: updatedTitle,
    }
  })
}

export const validatedEventTypes = eventTypes => {
  return eventTypes.map(event => {
    const validatedPercentage = Math.max(0, Math.min(100, event.percentage))
    const validatedTimeSpent = Math.max(0, parseFloat(event.timeSpentInHours) || 0)
    return {
      ...event,
      percentage: validatedPercentage,
      timeSpentInHours: validatedTimeSpent,
    }
  })
}

export const getLanguagePrefix = () => {
  const languagePrefix = window.location.pathname.startsWith("/en")
    ? `/${NAME_SPACE[0]}`
    : window.location.pathname.startsWith("/ar")
    ? `/${NAME_SPACE[1]}`
    : ""

  return languagePrefix
}

export const requiredValidator = fieldName => ({
  validator: (_, value) => {
    if (!value) return Promise.reject(`${t(fieldName)} ${t("is required")}`)
    return Promise.resolve()
  },
})

export const getLabelByKey = (key, list) => {
  return list?.find(item => item?.key || item?.value === key)?.label || null
}

export const getUniqueItemsArray = (items = [], keySelector) => {
  return Array.from(new Map(items.map(item => [keySelector(item), item])).values())
}

export const extractMimeType = base64String => {
  const match = base64String.match(/^data:(.+);base64,/)
  return match ? match[1] : null
}

export const sanitizeHTML = html => {
  return html?.replace(/[\uFEFF\u200B\u200C\u200D\u2060\u00AD]/g, "")
}

export const getCurrencySymbol = () => {
  return configs?.currencySymbolUnicode ? (
    <span className={configs?.currencySymbolClass} style={{ textTransform: "none" }}>
      {String.fromCharCode(configs.currencySymbolUnicode)}
    </span>
  ) : (
    <>{configs?.currency}</>
  )
}

export const mapKeysToValues = (array = [], key = "key", value = "id") => {
  const map = {}
  array.forEach(item => {
    if (item?.[key] && item?.[value] !== null) {
      map[item?.[key]] = item?.[value]
    }
  })
  return map
}

export const mapKeysToObject = (array = [], keyName = "key") => {
  return array?.reduce((acc, obj) => {
    const key = obj[keyName]
    if (key) acc[key] = obj
    return acc
  }, {})
}

export const arrayToObjectMap = (array, keyField) => {
  return array.reduce((acc, item) => {
    const key = item?.[keyField]
    if (key !== undefined) {
      acc[key] = item
    }
    return acc
  }, {})
}

export const getFlattenArray = array => {
  const flatten = array => {
    return array?.reduce((acc, item) => {
      acc.push(item)
      if (item?.children?.length > 0) {
        acc.push(...flatten(item.children))
      }
      return acc
    }, [])
  }

  return flatten(array)
}

export const isModule = moduleName =>
  (window?.location?.pathname?.split("/").length > 1 && window?.location?.pathname?.split("/")?.[2]) === moduleName

export const copyToClipboard = text => {
  navigator.clipboard.writeText(text)
  notify.success(t("Details copied successfully"))
}

export const mapRosterDataToWeekdays = data => {
  const mappedValues = []
  //3 is for active days/ in office key
  for (let i = 1; i <= 7; i++) {
    if (data?.[`Weekday${i}`]?.rosterStatus === 3) {
      mappedValues.push(`Weekday${i}`)
    }
  }
  return mappedValues
}

export const renderUnorderedList = (array, ulClassName) => {
  return (
    <ul className={ulClassName}>{Array.isArray(array) && array?.map(item => <li className="gray-900">{item}</li>)}</ul>
  )
}

export const checkMeetingTaskType = key => { 
  return (
    key === "outdoor" ||
    key === "site_office" ||
    key === "company_office" ||
    key === "zoom_call" ||
    key === "video_meeting" ||
    key === "whatsapp_video_call" ||
    key?.includes("meeting_done") ||
    key?.includes("meeting_attempted") ||
    key?.includes("google_meet")
  )
}

export const isDeepEqual = (a, b) => {
  if (a === b) return true
  if (typeof a !== typeof b) return false

  if (Array.isArray(a)) {
    return a?.length === b?.length && a?.every((item, i) => isDeepEqual(item, b?.[i]))
  }

  if (typeof a === "object") {
    const keysA = Object.keys(a ?? {})
    const keysB = Object.keys(b ?? {})
    return keysA?.length === keysB?.length && keysA?.every(key => isDeepEqual(a?.[key], b?.[key]))
  }

  return false
}
export const isValidEmail = value =>
  !!value && regex.emailRegex.test(value)
